import { pathOr } from 'ramda';
import { INewbuildingInfo } from '../../../../api/newbuildings';

export function getNewbuildingExtra(newbuildingInfo: INewbuildingInfo | null, targetPhone: string) {
  if (!newbuildingInfo) {
    return undefined;
  }

  const contacts = Array.isArray(newbuildingInfo.contacts) ? newbuildingInfo.contacts : [];
  const contact = contacts.find(contact => contact.phone === targetPhone);

  if (!contact) {
    return undefined;
  }

  const siteBlockId = pathOr(null, ['newbuildingDynamicCalltracking', 'siteBlockId'], contact);

  const isFromLeadFactory = contact.isLeadFactory;

  return {
    cplDynamicCalltracking: siteBlockId ? 1 : 0,
    cplCalltracking: isFromLeadFactory ? 0 : 1,
  };
}
